module.exports = __webpack_public_path__ + "static/media/unlocked.ecb4383a.svg";